// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__ew6PQ","page__section":"page_page__section__gXrsW"};